module.exports = __webpack_public_path__ + "static/istikbal-sm-1bf9d7ae2489eebd80a4b7e7aa90d45f.jpg";